@let actions = addItemActionButtonList();

@if (actions.length > 0) {
  <div class="flex flex-row gap-2">
    @for (action of actions; track $index) {
      @let visible = action.visible ?? true;

      @if (visible) {
        <snt-button-icon
          [icon]="`fa-light ${action.icon}`"
          [title]="`${action.title}` | transloco"
          (onClickAsync)="action.actionFn($event)"
        ></snt-button-icon>
      }
    }
  </div>
}
